import { SidebarTypes } from './types';

export const handlelSidebar = (status: boolean) => ({
	type: SidebarTypes.HANDLE_SIDEBAR,
	payload: status,
});
